import { Link } from "react-router-dom";
import { Logo } from "@/components/cast/Layout";
import legal from "@/lib/legal.json";

type Sec = { h: string; p: (string | string[])[] };

// Legal text lives in src/lib/legal.json; run scripts/build_legal.py after editing to refresh public/*.html
export default function Legal({ doc }: { doc: "privacy" | "terms" }) {
  const isP = doc === "privacy";
  const secs = (isP ? legal.privacy : legal.terms) as Sec[];
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <header className="border-b border-[#E2DBCE] bg-white/80 backdrop-blur"><div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4"><Link to="/" data-testid="legal-home-link"><Logo /></Link>
        <Link to={isP ? "/terms" : "/privacy"} className="text-sm font-semibold text-[#C86D51] hover:underline" data-testid="legal-switch-link">{isP ? "Terms of Service" : "Privacy Policy"}</Link></div></header>
      <main className="mx-auto max-w-3xl px-6 py-12" data-testid={`legal-${doc}`}>
        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#C86D51]">Cast · Legal</p>
        <h1 className="mt-2 font-display text-4xl font-semibold text-slate-900 sm:text-5xl" data-testid="legal-title">{isP ? "Privacy Policy" : "Terms of Service"}</h1>
        <p className="mt-2 text-sm text-slate-500">Last updated {legal.updated} · {legal.owner} · <a href={`mailto:${legal.email}`} className="hover:underline">{legal.email}</a></p>
        <div className="mt-10 space-y-9">
          {secs.map((s, i) => (
            <section key={s.h} id={s.h.toLowerCase().replace(/\W+/g, "-")}>
              <h2 className="font-display text-2xl font-semibold text-slate-900">{i + 1}. {s.h}</h2>
              {s.p.map((x, j) => Array.isArray(x)
                ? <ul key={j} className="mt-3 list-disc space-y-2 pl-5 text-slate-700">{x.map((li) => <li key={li}>{li}</li>)}</ul>
                : <p key={j} className="mt-3 leading-relaxed text-slate-700">{x}</p>)}
            </section>
          ))}
        </div>
      </main>
      <footer className="border-t border-[#E2DBCE] py-8 text-center text-sm text-slate-500">© {new Date().getFullYear()} {legal.owner} · <Link to="/privacy" className="hover:underline">Privacy</Link> · <Link to="/terms" className="hover:underline">Terms</Link> · <a href={`mailto:${legal.email}`} className="hover:underline">{legal.email}</a></footer>
    </div>
  );
}
